module.exports = __webpack_public_path__ + "static/media/synth-success.dc032ed9.webm";